import { Component, AfterViewInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { getBaseUrl } from '../../../app.module';
declare var tinymce: any;

@Component({
  selector: 'app-text-editor-control',
  template: `<textarea id="{{elementId}}">{{content}}</textarea>`
})
export class TextEditorControlComponent implements AfterViewInit, OnDestroy {
  @Input() elementId: string;
  @Input() content: string;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onEditorChange = new EventEmitter<any>();

  editor;

  ngAfterViewInit() {
    tinymce.init({
      selector: `#${this.elementId}`,
      plugins: ['link paste table autoresize charmap searchreplace lists advlist textcolor colorpicker code'],
      menubar: 'edit insert view format table tools',
      toolbar:
      "undo redo | formatselect | " +
      "bold italic backcolor | alignleft aligncenter " +
      "alignright alignjustify | bullist numlist outdent indent | " +
      "removeformat | fontselect  | help",
      browser_spellcheck: true,
      language : 'es',
      contextmenu: false,
      table_default_attributes: {},
      table_default_styles: {},
      table_responsive_width: false,
      forced_root_block : 'div',
      setup: editor => {
        this.editor = editor;
        editor.on('Change', () => {
          const content = editor.getContent();
          this.onEditorChange.emit(content);
        });
      }
    });
  }

  ngOnDestroy() {
    tinymce.remove(this.editor);
  }
}
